import DashboardListItemModel from '@/models/dashboards/dashboard-list-item-model'
import IDashboardsState from './interfaces/dashboards-state'

export default class DashboardsState implements IDashboardsState {
  public dashboards: DashboardListItemModel[] = []
  public loadingDashboards = false
}
